import { render } from "./account-button.vue?vue&type=template&id=831a723c"
import script from "./account-button.vue?vue&type=script&lang=js"
export * from "./account-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__